import { RouteName } from './route-names';
import Main from '../views/Main';
import User from '../views/User/User';
import AllStores from '../views/Stores/AllStores/AllStores';
import Contact from '../views/Contact/Contact';
import New from '../views/New/New';
import LendIqos from '../views/New/LendIqos/LendIqos';
import IqosStores from '../views/Stores/IqosStores/IqosStores';
import BuyIqos from '../views/BuyIqos/BuyIqos';
import BuyBonds from '../views/BuyBonds/BuyBonds';
import ResellerStores from '../views/Stores/ResellerStores/ResellerStores';
import BuyHeets from '../views/User/BuyHeets/BuyHeets';
import Clean from '../views/User/Clean/Clean';
import Accessories from '../views/User/Customize/Accessories/Accessories';
import Customize from '../views/User/Customize/Customize';
import Engraving from '../views/User/Customize/Engraving/Engraving';
import Recharge from '../views/User/Recharge/Recharge';
import Maintenance from '../views/User/Maintenance/Maintenance';
import SubmitQuestion from '../views/Contact/SubmitQuestion/SubmitQuestion';
import { routePaths } from './paths';
import routesMetaData from './routes-meta-data';
// IMPORTANT: this configuration is strictly bounded to StoreLocatorController so update both accordingly!
const routes = [
    {
        name: RouteName.Main,
        path: routePaths[RouteName.Main],
        component: Main,
        meta: routesMetaData[RouteName.Main],
    },
    {
        name: RouteName.AllStoresWithParameter,
        path: routePaths[RouteName.AllStoresWithParameter],
        component: AllStores,
        meta: routesMetaData[RouteName.AllStoresWithParameter],
    },
    {
        name: RouteName.AllStores,
        path: routePaths[RouteName.AllStores],
        component: AllStores,
        meta: routesMetaData[RouteName.AllStores],
    },
    {
        name: RouteName.IqosStores,
        path: routePaths[RouteName.IqosStores],
        component: IqosStores,
        meta: routesMetaData[RouteName.IqosStores],
    },
    {
        name: RouteName.ResellerStores,
        path: routePaths[RouteName.ResellerStores],
        component: ResellerStores,
        meta: routesMetaData[RouteName.ResellerStores],
    },
    {
        name: RouteName.User,
        path: routePaths[RouteName.User],
        component: User,
        meta: routesMetaData[RouteName.User],
    },
    {
        name: RouteName.Recharge,
        path: routePaths[RouteName.Recharge],
        component: Recharge,
        meta: routesMetaData[RouteName.Recharge],
    },
    {
        name: RouteName.Maintenance,
        path: routePaths[RouteName.Maintenance],
        component: Maintenance,
        meta: routesMetaData[RouteName.Maintenance],
    },
    {
        name: RouteName.Clean,
        path: routePaths[RouteName.Clean],
        component: Clean,
        meta: routesMetaData[RouteName.Clean],
    },
    {
        name: RouteName.Customize,
        path: routePaths[RouteName.Customize],
        component: Customize,
        meta: routesMetaData[RouteName.Customize],
    },
    {
        name: RouteName.Accessories,
        path: routePaths[RouteName.Accessories],
        component: Accessories,
        meta: routesMetaData[RouteName.Accessories],
    },
    {
        name: RouteName.Engraving,
        path: routePaths[RouteName.Engraving],
        component: Engraving,
        meta: routesMetaData[RouteName.Engraving],
    },
    {
        name: RouteName.BuyHeets,
        path: routePaths[RouteName.BuyHeets],
        component: BuyHeets,
        meta: routesMetaData[RouteName.BuyHeets],
    },
    {
        name: RouteName.BuyIqos,
        path: routePaths[RouteName.BuyIqos],
        component: BuyIqos,
        meta: routesMetaData[RouteName.BuyIqos],
    },
    {
        name: RouteName.BuyBonds,
        path: routePaths[RouteName.BuyBonds],
        component: BuyBonds,
        meta: routesMetaData[RouteName.BuyBonds],
    },
    {
        name: RouteName.New,
        path: routePaths[RouteName.New],
        component: New,
        meta: routesMetaData[RouteName.New],
    },
    {
        name: RouteName.LendIqos,
        path: routePaths[RouteName.LendIqos],
        component: LendIqos,
        meta: routesMetaData[RouteName.LendIqos],
    },
    {
        name: RouteName.Contact,
        path: routePaths[RouteName.Contact],
        component: Contact,
        meta: routesMetaData[RouteName.Contact],
    },
    {
        name: RouteName.SubmitQuestion,
        path: routePaths[RouteName.SubmitQuestion],
        component: SubmitQuestion,
        meta: routesMetaData[RouteName.SubmitQuestion],
    },
    {
        path: {
            en: '*',
            lv: '*',
            ru: '*',
        },
    },
];
export default routes;
